import { Tooltip } from "antd";
import React from "react";
interface Props {
  children: React.ReactNode;
  msg: string;
  placement?: "top" | "bottom" | "topLeft";
}
export default function Commontooltip({ children, msg, placement }: Props) {
  return (
    <Tooltip title={msg} placement={placement}>
      {children}
    </Tooltip>
  );
}
